<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>{{ currentName }}</span></p>
        <div class="artcle-box">
            <div class="menu" v-show="widthNew">
                <el-menu
            
                    class="el-menu-vertical-demo"
                    default-active='1'
                    background-color="#fff"
                    active-text-color="#00a8a8">
                        <el-menu-item index="1" @click="ClickArry()">全部</el-menu-item>
                        <el-menu-item v-for="item,index in maintypeData" :key="item.cate_id" :index="2+index.toString()" @click="handleListarticle(item)">
                            <span slot="title">{{ item.cate_name }}</span>
                        </el-menu-item>
                
                </el-menu>
            </div>
            <div class="infoNav4"  v-show="!widthNew">
                <ul>
                    <li class="slotPoper" @click="ClickArry()" :class="active== -1?'slotPoperColor':''">全部</li>
                    <li class="slotPoper"  @click="handleListarticle(item,index)"
                        :class="index==active?'slotPoperColor':''"
                        v-for="item,index in maintypeData" :key="item.cate_id" :index="2+index.toString()">{{ item.cate_name }}</li>
                </ul>
            </div>
            <div class="artcle-right">
                <div class="search-page">
                    <Search  class="searchWidthArticle" @inputKey="inputKey"></Search>
                </div>
                <div v-for="item in listarticle" :key="item.id">
                    <div class="content-div" @click="handleDetail(item)">
                        <img :src="item.firstFile.FileUrl" alt="" v-show="item.firstFile.FileUrl">
                        <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl">
                        <div>
                            <p class="title-p">{{ item.title }}</p>
                            <p class="time-p">{{ item.create_time }}</p>
                            
                        </div>
                        
                    </div>
                    <el-divider   ></el-divider>
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeDate } from "@/js/getTime";
import Search from "../search/index.vue"
export default({
    data(){
        return{
            innerWidth: '',
            input: '',
            total: 0,
            hideOnSinglePage: true,
            currentChange: 1,
            cate_values: ['maintype','cindustry'],
            // cate_values: ['maintype','industry'],
            // cate_values: ['company'],
            maintypeData:[],
            listarticle: [],
            channel: sessionStorage.getItem("channel"),
            maintype_ids: '',
            currentName: '',
            Newkeywords:'',
            widthNew: false,
            active: -1
        }
    },
    components: {
        Search,
    },
    watch: {
        '$route' () {
            this._initData();//我的初始化方法
        },
        maintype_ids(newVal,lodVal){
            this.maintype_ids = newVal
            sessionStorage.setItem('typeId',newVal);
            this.currentName = sessionStorage.getItem("name")
            let data = {
                channel: sessionStorage.getItem("channel"),
                pageNum: 1,
                pageSize: 20,
                maintype_ids: newVal,
                keywords: ''
            }
            this.getListArry(data)
        }
        
    },
    methods:{
         //   获取菜单
        getMenuList(){
            const data = {
                pageNum: 1,
                pageSize: 999999,
                cate_values: this.cate_values,
            }
            this.$store.dispatch('menu/menuList', data)
                .then((res) => {
                    this.maintypeData = []
                    if(res.ok){
                        const list = res.data.items
                        if(list.length != 0){
                            this.maintypeData = list
                        }
                     
                    }
                
                })
                .catch((err) => {
                    
                    console.log(err);
                }) 
        },
        //   根据不同的channel来查询
        getListArry(data){
            this.$store.dispatch('menu/getMenu',data)
                .then(res => {
                
                    if(res.ok){
                        this.listarticle = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                    this.listarticle.map(item => {
                        item.create_time = getTimeDate(item.create_time)
                    })


                }).catch(err => {
                    console.log(err);s
                })
        },

        ClickArry(){
            const data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                maintype_ids: '',
                keywords: '',
            }
            this.getListArry(data)
        },
        handleListarticle(value,index){
            this.active = index
            let data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                maintype_ids: value.cate_id,
                keywords: ''
            }
            this.currentName = value.cate_name
            this.maintype_ids= value.cate_id,
            this.getListArry(data)
          
        },

        handleCurrentChange(val){
            this.currentChange = val
            let data = {
                channel: this.channel,
                pageNum: val,
                pageSize: 20,
                maintype_ids: this.maintype_ids,
                keywords: this.Newkeywords
            }
            this.getListArry(data)
        },
        handleDetail(item){
            
            const { href } = this.$router.resolve({
                path: "/detailPages",
                query: {
                    key: item.id,
                    currentName: this.currentName
                }
            });
            window.open(href, '_blank');
        },
        inputKey(val){
            this.Newkeywords = val
            let data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                maintype_ids: this.maintype_ids,
                keywords: val
            }

            this.getListArry(data)
        }
    },
    mounted(){
        if(sessionStorage.getItem("name") == '法律法规'){
            if(!localStorage.getItem('token')){
                this.$notify({
                title: '提示',
                message: '未登录或超时，请重新登陆',
                type: 'error'
                })
                this.$router.push('/login')
            }
        }
        this.currentName = sessionStorage.getItem("name")
        this.maintype_ids = sessionStorage.getItem("typeId")
        this.channel = sessionStorage.getItem("channel")

        let data = {
            channel: this.channel,
            pageNum: 1,
            pageSize: 20,
            maintype_ids: this.maintype_ids,
            keywords: ''
        }
        
        this.getListArry(data)
        window.addEventListener('setItem', ()=> {
            this.maintype_ids = sessionStorage.getItem('typeId');
        })
   
    },
    
    created(){
        
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        this.getMenuList()
        
       
    }
})
</script>

<style>
@import url(../../css/channelPolicy.css);


.search-page{
    padding: 10px 0 10px 0px;
    background: #fff;
    height: 45px;width: 100%;
}
@media screen and (min-width: 541px) {
   
    .searchWidthArticle{
        margin-bottom: 40px;
        width: 600px;
    }
}
@media screen and (max-width: 540px) {
   
   .searchWidthArticle{
       padding-left: 0px;
       margin: 0 auto;
       margin-bottom: 40px;
       width: 95%
   }
}
</style>